// Sport-aware video content taxonomy (Tier-2 SP5).
//
// The backend attaches a `content_type` to every video (derived from the legacy
// `category` when unset). These are the athlete-facing content types — distinct
// from the legacy storage `category` (in_season/off_season/combine/staged/
// verification), which is unchanged and still the slot key.
//
// Ordered list drives both the editor <select> and the read-only grouping order.
export const VIDEO_CONTENT_TYPES = [
  { value: 'game_competition', label: 'Full Game / Competition' },
  { value: 'skills_reel', label: 'Skills / Mechanics Reel' },
  { value: 'showcase_event', label: 'Showcase / Event' },
  { value: 'highlight', label: 'Highlight Reel' },
  { value: 'full_routine', label: 'Full Routine' },
];

// value -> display label
export const VIDEO_CONTENT_TYPE_LABELS = VIDEO_CONTENT_TYPES.reduce((acc, t) => {
  acc[t.value] = t.label;
  return acc;
}, {});

// Where videos with a null / unknown content_type land on read.
export const DEFAULT_VIDEO_CONTENT_TYPE = 'highlight';

// Display label for a content_type value, falling back to the default bucket
// ("Highlight Reel") for null / unrecognized values.
export function contentTypeLabel(contentType) {
  return VIDEO_CONTENT_TYPE_LABELS[contentType] || VIDEO_CONTENT_TYPE_LABELS[DEFAULT_VIDEO_CONTENT_TYPE];
}

// Group a flat list of videos by content_type. Videos whose content_type is
// null or unrecognized fall under the default bucket (Highlight Reel). Returns
// an ordered array (following VIDEO_CONTENT_TYPES order) of
// { contentType, label, videos } for only the buckets that have videos.
export function groupVideosByContentType(videos) {
  const buckets = {};
  (videos || []).forEach((v) => {
    const key = VIDEO_CONTENT_TYPE_LABELS[v && v.content_type]
      ? v.content_type
      : DEFAULT_VIDEO_CONTENT_TYPE;
    if (!buckets[key]) buckets[key] = [];
    buckets[key].push(v);
  });
  return VIDEO_CONTENT_TYPES
    .filter((t) => buckets[t.value])
    .map((t) => ({ contentType: t.value, label: t.label, videos: buckets[t.value] }));
}
